import React from 'react'
import { Routes, Route, useResolvedPath } from 'react-router-dom'

import { DataManagementMainView } from './DataManagementMainView'
import { BulkDistrictDataView } from './BulkDistrictDataView'
import { DistrictsQuickActionsView } from './DistrictsQuickActionsView'
import { DistrictListView } from './DistrictListView'

export const DataManagementView: React.FC = () => {
  const { pathname } = useResolvedPath('/admin/management')
  console.log(`${pathname}/districts/import`)
  return (
    <Routes>
      <Route path={pathname}>
        <DataManagementMainView />
      </Route>
      <Route path={`${pathname}/districts/import`}>
        <BulkDistrictDataView />
      </Route>
      <Route path={`${pathname}/districts/manage`}>
        <DistrictListView />
      </Route>
      <Route path={`${pathname}/districts`}>
        <DistrictsQuickActionsView />
      </Route>
    </Routes>
  )
}
